import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { deposit, pendingTransaction, transaction } from '../../../types/dex';

const SectionTableHead = ({title}:{title: string}) => {
    return ( 
        <TableHead>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                    <b>{title}</b>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

const ResponsiveCell = ({value}: {value: string}) => (
    <TableCell 
        align="right"
        sx={{
            maxWidth: {xs: "50px"},
            overflow: {xs: "hidden"},
            textOverflow: {xs: "ellipsis"},
            whiteSpace: {xs: "nowrap"},
        }}
    >
        {value}
    </TableCell>
); 

const Row = ({field, value}: {field: string, value: string}) => {
    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row">{field}</TableCell>
            <ResponsiveCell value={value} />
        </TableRow>
    )
}

export const DepositSectionTable = ({deposit }:{deposit: deposit}) => {
    return (
        <Table  aria-label="deposit table">
            <SectionTableHead title="Deposit To Dex:" />
            <TableBody>
                <Row field='Value' value={`${deposit.value} ${deposit.asset}`}/>
                <Row field='Date' value={deposit.date}/>
                <Row field='Transfer ID' value={deposit.transaction_id}/>
                <Row field='Transfer Status' value={deposit.transfer_status}/>
                <Row field='Network fee' value={deposit.network_fee}/>
            </TableBody>
        </Table>
    );
}

export const TxSectionTable = ({tx}:{tx: transaction}) => {
    return (
        <Table aria-label="Tranfer table">
            <SectionTableHead title="Tranfer From Dex:" />
            <TableBody>
                <Row field={`Transfer from DEX (${tx.transfer_status})`} value={`${Number(tx.value) * (-1)} ${tx.asset}`}/>
                <Row field='Date' value={tx.date}/>
                <Row field='Transfer ID' value={tx.transaction_id}/>
                <Row field='Network fee' value={`${Number(tx.network_fee) * (-1)}`}/>
            </TableBody>
        </Table>
    );
}

export const PendingSectionTable = ({pending}: {pending: pendingTransaction}) => {
    return (
        <Table  aria-label="pending table">
            <SectionTableHead title={`${(pending.value < 0) ? "Debit" : "Credit"}: `} />
            <TableBody>
                <Row field={`${(pending.value < 0)?"Debit":"Credit"}`} value={`${pending.value} ${pending.asset}`}/>
                <Row field='Rate' value={`${pending.meta_data.rate}`}/>
                <Row field='Exchange Fee ' value={`${pending.meta_data.taker_buy_exchange_fee}`}/>
                <Row field='Date' value={pending.date}/>
            </TableBody>
        </Table>
    );
}


